import cx from 'classnames'
import { FC, HTMLAttributes, ReactNode } from 'react'

import InfoIcon from 'src/components/ui/atoms/Icons/InfoIcon'

import * as styles from './PanelInfo.scss'

export interface PanelInfoProps extends HTMLAttributes<HTMLDivElement> {
  label: ReactNode
}

const PanelInfo: FC<PanelInfoProps> = ({ label, className, ...divProps }) => {
  return (
    <div className={cx(styles.PanelInfo, className)} role="blockquote" {...divProps}>
      <div className={styles.InfoContent}>
        <InfoIcon className={styles.InfoIcon} />

        <div className={styles.InfoText}>{label}</div>
      </div>
    </div>
  )
}

export default PanelInfo
